import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseComponent } from 'projects/ProjetoBaseAngular/app/base.component';
import { MetaMsgTemplateParametroModel } from '../../../../../domain/models';
import { MetaMsgTemplateParametroNomeMaxLength, MetaMsgTemplateParametroOrigemGrupos } from 'projects/admin/src/domain/consts';

@Component({
  selector: 'app-meta-msg-template-component-parametro-modal',
  templateUrl: './parametro-modal.component.html'
})
export class MetaMsgTemplateComponentParametroModalComponent extends BaseComponent {
  @ViewChild('modal') modal: ModalDirective;
  @Output() modalSave: EventEmitter<MetaMsgTemplateParametroModel> = new EventEmitter<MetaMsgTemplateParametroModel>();
  @Input() origemObrigatoria = false;

  form: FormGroup;
  errors: string[] = [];
  readonly parametroNomeMaxLength = MetaMsgTemplateParametroNomeMaxLength;
  readonly origemGrupos = MetaMsgTemplateParametroOrigemGrupos;

  constructor(injector: Injector) {
    super(injector);
  }

  show(model: MetaMsgTemplateParametroModel) {
    this.errors = [];
    this.initializeForm(Object.assign(new MetaMsgTemplateParametroModel(), model));
    this.modal.show();
  }

  save() {
    this.errors = [];
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      const nomeControl = this.form.get('nome');
      if (nomeControl.hasError('maxlength')) {
        this.errors.push(`O parâmetro '${nomeControl.value}' deve ter no máximo ${this.parametroNomeMaxLength} caracteres.`);
      } else {
        this.errors.push('Verifique se todos os campos obrigatórios foram preenchidos!');
      }
      return;
    }

    const model = Object.assign(new MetaMsgTemplateParametroModel(), this.form.value);
    this.modalSave.emit(model);
    this.close();
  }

  close() {
    this.errors = [];
    this.form = null;
    this.modal.hide();
  }

  isOrigemLegada(): boolean {
    const origem = this.form?.value?.origem;
    return !!origem && !this.origemGrupos.some(grupo =>
      grupo.opcoes.some(opcao => opcao.valor === origem));
  }

  getDescricaoOrigem(): string {
    const origem = this.form?.value?.origem;
    if (!origem) {
      return 'Utilize esta opção quando os parâmetros forem informados manualmente no envio.';
    }

    for (const grupo of this.origemGrupos) {
      const opcao = grupo.opcoes.find(item => item.valor === origem);
      if (opcao) {
        return opcao.descricao;
      }
    }

    return 'Origem antiga ou não reconhecida. Selecione uma origem válida antes de usar este template na confirmação de presença.';
  }

  private initializeForm(model: MetaMsgTemplateParametroModel) {
    this.form = this.formBuilder.group({
      id: [model.id],
      dataInclusao: [model.dataInclusao],
      dataAlteracao: [model.dataAlteracao],
      registroAtivo: [model.registroAtivo],
      metaMsgTemplateComponentId: [model.metaMsgTemplateComponentId],
      ordem: [model.ordem, [Validators.required, Validators.min(1)]],
      nome: [model.nome, [Validators.required, Validators.maxLength(this.parametroNomeMaxLength), Validators.pattern(/^[a-zA-Z0-9_]+$/)]],
      exemplo: [model.exemplo, [Validators.required, Validators.maxLength(500)]],
      origem: [model.origem, this.origemObrigatoria
        ? [Validators.required, Validators.maxLength(200)]
        : Validators.maxLength(200)],
      descricao: [model.descricao, Validators.maxLength(500)]
    });
  }
}
